import { createApiCall } from "services/api/createApiCall";
import { transformErrorResponse } from "services/api/transformation";

import { ActivityItem, PlatformTenant, PlatformTrends } from "./types";

const BASE = "/v1/admin/platform";

const transformTenant = (res: any): PlatformTenant => ({
  tenantId: res.tenantId,
  name: res.name,
  tenantTypeName: res.tenantTypeName ?? null,
  email: res.email ?? null,
  vehicleCount: res.vehicleCount ?? 0,
  publishedVehicleCount: res.publishedVehicleCount ?? 0,
  draftVehicleCount: res.draftVehicleCount ?? 0,
  userCount: res.userCount ?? 0,
  outgoingInvoiceCount: res.outgoingInvoiceCount ?? 0,
  incomingInvoiceCount: res.incomingInvoiceCount ?? 0,
  revenue: res.revenue ?? 0,
  expense: res.expense ?? 0,
  pricingSchemeName: res.pricingSchemeName ?? null,
  minimumMonthly: res.minimumMonthly ?? null,
  monthlyRecurring: res.monthlyRecurring ?? null,
  lastActivity: res.lastActivity ?? null,
  created: res.created ?? null,
});

const transformActivity = (res: any): ActivityItem => ({
  id: res.id,
  tenantId: res.tenantId,
  comment: res.comment,
  entityName: res.entityName ?? null,
  type: res.type,
  userId: res.userId,
  userFullName: res.userFullName ?? null,
  created: res.created,
});

/*---------------------------------------------------------------------------------------
    METRIKE SVIH KLIJENATA
-----------------------------------------------------------------------------------------*/
export const getPlatformTenantsAPI = async (): Promise<PlatformTenant[]> => {
  const response = await createApiCall(
    { path: `${BASE}/tenants`, method: "GET" },
    { getMessage: { error: (error: any) => `${transformErrorResponse(error)}` } }
  )();

  return (response.data?.results ?? []).map(transformTenant);
};

/*---------------------------------------------------------------------------------------
    METRIKE JEDNOG KLIJENTA
-----------------------------------------------------------------------------------------*/
export const getTenantMetricsAPI = async (tenantId: string): Promise<PlatformTenant> => {
  const response = await createApiCall(
    { path: `${BASE}/tenants/${tenantId}`, method: "GET" },
    { getMessage: { error: (error: any) => `${transformErrorResponse(error)}` } }
  )();

  return transformTenant(response.data);
};

/*---------------------------------------------------------------------------------------
    ZADNJE AKTIVNOSTI KROZ SVE KLIJENTE
-----------------------------------------------------------------------------------------*/
export const getPlatformActivityAPI = async (take = 25): Promise<ActivityItem[]> => {
  const response = await createApiCall(
    { path: `${BASE}/activity?take=${take}`, method: "GET" },
    { getMessage: { error: (error: any) => `${transformErrorResponse(error)}` } }
  )();

  return (response.data?.results ?? []).map(transformActivity);
};

/*---------------------------------------------------------------------------------------
    TRENDOVI

    Novi klijenti su stvarni. MRR serija nije povijesni snimak — vidi `PlatformTrends`.
-----------------------------------------------------------------------------------------*/
export const getPlatformTrendsAPI = async (months = 12): Promise<PlatformTrends> => {
  const response = await createApiCall(
    { path: `${BASE}/trends?months=${months}`, method: "GET" },
    { getMessage: { error: (error: any) => `${transformErrorResponse(error)}` } }
  )();

  return {
    newTenants: (response.data?.newTenants ?? []).map((p: any) => ({
      month: p.month,
      value: p.value,
    })),
    mrr: (response.data?.mrr ?? []).map((p: any) => ({ month: p.month, value: p.value })),
    combinations: (response.data?.combinations ?? []).map((c: any) => ({
      keyCode: c.keyCode,
      tenantCount: c.tenantCount,
      mrr: c.mrr,
    })),
  };
};
